import React from 'react';

const CampaignSectors = ({
  id = 'segmentos',
  ariaLabel,
  kicker,
  title,
  ctaLabel,
  onCtaClick,
  cards,
}) => (
  <section id={id} className="hhc-segmentos" aria-label={ariaLabel}>
    <div className="hhc-seg-header">
      <div className="hhc-seg-left hhc-reveal">
        <div className="hhc-kicker">{kicker}</div>
        <h2 className="hhc-h-display hhc-seg-title">{title}</h2>
      </div>
      <a href="#contato" className="hhc-btn hhc-btn-outline-red hhc-reveal" onClick={onCtaClick}>
        {ctaLabel}
      </a>
    </div>

    <div className="hhc-seg-grid">
      {cards.map((card, index) => (
        <div
          key={card.id ?? card.name}
          className="hhc-seg-card hhc-reveal"
          style={{ transitionDelay: `${0.05 + index * 0.03}s` }}
        >
          <div className="hhc-seg-icon" aria-hidden="true">
            {card.icon}
          </div>
          <div className="hhc-seg-name">{card.name}</div>
        </div>
      ))}
    </div>
  </section>
);

export default CampaignSectors;
